import React from 'react';
import './Line.scss';

const Row = (props) => {
  let lineClass = "line line_spaces";
  if (props.className) {
    lineClass += ` ${props.className}`;
  }
  const cardStyle = props.clearStyle ? null : "card-grid";

  return (
    <div className={lineClass}>
      { props.title && (
        <div className="row align-center">
          <div className="column">
            <h3 className="header">{props.title}</h3>
          </div>
        </div>
      )}
      { props.secondary && (
        <div className="row align-center">
          <div className="column small-9">
            <h6 className="secondary">{props.secondary}</h6>
          </div>
        </div>
      )}
      <div className="row">
        <div className={cardStyle} style={props.style}>
          {props.children}
        </div>
      </div>
    </div>
  );
};

Row.propTypes = {};
Row.defaultProps = {
  clearStyle: false
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/Common/Line/Line.jsx